export default "__VITE_ASSET__CfdB$LOl__"